import { Component } from '@angular/core';

@Component({
    selector: 'loading',
    template: `<div id="loading-overlay" class="loading-overlay">
        <div class="loading-overlay-box">
            <svg-icon icon="icon_loading" iconClass="spin"></svg-icon>
        </div>
    </div>`,
})

export class LoadingComponent {}
